import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type { Session } from '../types'

export interface AuthState {
  /** This tab's session. Initialised from `sessionStorage`; never shared with other tabs. */
  session: Session | null
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: { session: null } as AuthState,
  reducers: {
    signedIn(state, action: PayloadAction<Session>) {
      state.session = action.payload
    },
    signedOut(state) {
      state.session = null
    },
  },
})

export const { signedIn, signedOut } = authSlice.actions
